import { axiosClient } from "../utils";

export const AppsAPI = {
  getTags: async () => {
    const res = await axiosClient.get(`/onboarding?type=get-tags`);
    return res.data;
  },
  getApps: async (params) => {
    const res = await axiosClient.get(`/onboarding?type=get-apps${params.toString() ? `&${params}` : ""}`);
    return res.data;
  },
  getApp: async (slug) => {
    const res = await axiosClient.get(`/onboarding?type=get-app&slug=${slug}`);
    return res.data;
  },
  submitEnquire: async (payload) => {
    const res = await axiosClient.post(`/onboarding?type=save-enquire`, payload);
    return res.data;
  }
};